import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

interface Plan {
  name: string
  price: string
  /** What the price is per, where the free plan runs out instead. */
  per?: string
  /** The one the fleet is on; it is not something you can buy again. */
  current?: boolean
}

const PLANS: Plan[] = [
  { name: 'Free', price: '$0', current: true },
  { name: 'Basic', price: '$20', per: 'per month' },
  { name: 'Pro', price: '$50', per: 'per month' },
]

/** What is left of the trial, under the composer where the agent is being used. */
export function TrialNotice({ daysLeft = 4 }: { daysLeft?: number }) {
  const left = `${daysLeft} days left`
  return (
    <p className="text-ink-400 px-3 pt-2 pb-1 text-center text-[10px]">
      {daysLeft} days left in your free trial.{' '}
      <Dialog>
        <DialogTrigger className="text-ink underline underline-offset-2">Upgrade today</DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Pricing plan</DialogTitle>
            <DialogDescription>Change or cancel whenever you like.</DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-3 gap-3">
            {PLANS.map((plan) => (
              <div
                key={plan.name}
                className={cn(
                  'flex flex-col items-center gap-2 rounded-md border p-4 text-center',
                  plan.current ? 'border-brand bg-brand/5' : 'border-ink-100'
                )}
              >
                <span className="text-ink text-sm font-semibold">{plan.name}</span>
                <span className="text-ink text-xl font-bold tracking-tight">{plan.price}</span>
                <span className="text-ink-400 text-[10px]">{plan.per ?? left}</span>
                {plan.current ? (
                  <Badge variant="secondary" className="mt-1 text-[10px]">
                    Current plan
                  </Badge>
                ) : (
                  <Button size="sm" className="mt-1 text-xs">
                    Upgrade
                  </Button>
                )}
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </p>
  )
}
